import { helpCenterDocumentStore } from '@/services/HelpCenterDocument/store'
import { notifyMessage, notifyProblem, notifyWarning } from '@/services/notify'

export const methods = {
  async downloadPdf(helpCenterDocumentID, documentURL) {
    if (this.isDebug == true) console.debug('downloadPdf...' + helpCenterDocumentID)

    if (!helpCenterDocumentID || helpCenterDocumentID == undefined) {
      notifyProblem('There is a problem downloading this document.')
    }

    try {
      var link = document.createElement('a')
      link.download = 'download.pdf'
      link.setAttribute('download', 'download.pdf')
      link.href = documentURL
      window.open(link, '_blank')
      notifyMessage(`Successfully opened the help center document in a new tab.`)
      return
    } catch (e) {
      if (this.isDebug == true) console.debug(e)
      notifyWarning('There was a problem opening the help center document.')
    }
  },

  async reload() {
    console.debug('in reload....')
    this.loading = true

    await this.loadHelpCenterSubjects()

    this.loading = false
  },

  async loadHelpCenterSubjects() {
    this.loading = false

    try {
      await helpCenterDocumentStore.dispatch('getHelpCenterDocuentList').then(({ list }) => {
        this.documents = list
        this.loading = false
      })
    } catch (e) {
      this.loading = false
    }
    this.loading = false
  }
}
